import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '@vds-core/theme';
import TypographyConfig from '../../typographyConfig';
import defaultConfig from './config';
import fontColorPropType from '../../util/fontColorPropType';
import { Typography } from '../Typography';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * Primitive used for the component.
   */
  primitive: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'p']),

  /**
   * Viewport the font styling is based on. Desktop and tablet are the same size.
   */
  viewport: PropTypes.oneOf(['desktop', 'tablet', 'mobile']),

  /**
   * Content that will be passed to the component.
   */
  children: PropTypes.node,

  /**
   * Color of the text.
   */
  color: fontColorPropType,

  /**
   * Allows for specific typescale to be passed to override global config.
   */
  typescale: PropTypes.oneOf(['VDS', 'MVP', 'Marketing']),

  /**
   * If the theme object contains the `typescale` key and no typescale prop was passed global typescale is overriden by theme.
   */
  theme: PropTypes.object,

  /**
   * The tabIndex of the text.
   */
  tabIndex: PropTypes.number,

  /**
   * @ignore
   */
  config: PropTypes.object,

  /**
   * Assigns an Id to the component
   */
  id: PropTypes.string,

  /**
   * Adds an aria-labelledby attribute to the component
   */
  ariaLabelledBy: PropTypes.string
};
var defaultProps = {
  primitive: 'p',
  viewport: 'desktop',
  children: null,
  color: colors.black,
  config: defaultConfig //tabIndex: 0,

};
var StyledSubtitle = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "StyledSubtitle",
  componentId: "ufzqxp-0"
})(_templateObject());

var Subtitle = function Subtitle(props) {
  var children = props.children,
      primitive = props.primitive,
      viewport = props.viewport,
      color = props.color,
      typescale = props.typescale,
      theme = props.theme,
      tabIndex = props.tabIndex,
      config = props.config,
      fontsConfigProp = props.fontsConfig,
      ariaLabel = props.ariaLabel,
      id = props.id,
      ariaLabelledBy = props.ariaLabelledBy;
  var // What typescale is being used for configuration
  typescaleToUse = typescale ? typescale : theme && theme.typescale ? theme.typescale : TypographyConfig.getTypescale(),
      viewportToUse = viewport === 'mobile' ? 'mobile' : 'desktop',
      // What is the specific font configuration we are using
  fontConfig = config[typescaleToUse][viewportToUse];

  function _onClick(e) {
    if (e.type === 'click') {
      e.currentTarget.blur();
    }
  }

  return /*#__PURE__*/React.createElement(StyledSubtitle, {
    fontSize: fontConfig.fontSize,
    fontWeight: fontConfig.fontWeight,
    fontFamily: fontConfig.fontFamily,
    lineheight: fontConfig.lineHeight,
    primitive: primitive,
    color: color,
    tabIndex: tabIndex,
    "aria-hidden": tabIndex < 0,
    onClick: _onClick,
    fontsconfig: fontsConfigProp,
    "aria-label": ariaLabel,
    id: id,
    "aria-labelledby": ariaLabelledBy
  }, children);
};

Subtitle.propTypes = propTypes;
Subtitle.defaultProps = defaultProps;
export default withVDSManager(Subtitle);